module.exports = __webpack_public_path__ + "img/illustrator.5d573074.svg";